/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import slugify from '../../../../utils/slugify';

// import Checkbox from '@material-ui/core/Checkbox';
// import { withStyles } from '@material-ui/core/styles';

// const PageTypeCheckbox = withStyles({
//   root: {
//     color: 'black',
//     padding: 0,
//     marginRight: '0.5rem',
//   },
//   checked: {},
// })(props => <Checkbox color="default" {...props} />);

const Anchor = ({
  activeLanguage, handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'Separator',
    borderWidth: 3,
    color: 'black',
    marginTop: true,
    anchor: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isColorTransparent, setColorTransparent] = useState(false);
  const [isBorderThin, setBorderThin] = useState(false);

  useEffect(() => {
    if (index >= 0 && components.length) {
      const { component } = components[index];
      const borderWidth = isBorderThin ? 1 : 3;
      const borderColor = isColorTransparent ? 'transparent' : 'black';

      const comp = {
        ...component,
        borderWidth,
        color: borderColor,
      };

      setState(comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  }, [isColorTransparent, isBorderThin]);

  const inputHandler = (e) => {
    const { value } = e.target;
    const sluggedValue = slugify(value);

    const { component } = components[index];

    const comp = {
      ...component,
      anchor: sluggedValue,
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);

      if (component) {
        component.color === 'transparent' ? setColorTransparent(true) : setColorTransparent(false);
        component.borderWidth === 1 ? setBorderThin(true) : setBorderThin(false);
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  return (
    <>
      <div className="w-full p-1 bg-greyFilter rounded-lg">
        <div className="pl-4 bg-greyFilter pl-13 pr-2 flex items-center">
          <label className="flex flex-col font-americaMonoRegular text-xs uppercase text-black" htmlFor="borderColor">
            Border Color
            <div className="mt-1 pb-0">
              <label className="switch mb-0 pb-0 h-6">
                <input className="switch" checked={isColorTransparent} onChange={() => setColorTransparent(!isColorTransparent)} type="checkbox" />
                <div className="switch-slider btn-btransp switch-round" />
              </label>
            </div>
          </label>
          <label className=" ml-12 flex flex-col font-americaMonoRegular text-xs uppercase text-black" htmlFor="borderWidth">
            Border Width
            <div className="mt-1 pb-0">
              <label className="switch mb-0 pb-0 h-6">
                <input className="switch" checked={isBorderThin} onChange={() => setBorderThin(!isBorderThin)} type="checkbox" />
                <div className="switch-slider btn-border switch-round" />
              </label>
            </div>
          </label>
          <label className="ml-12 flex flex-row items-center font-americaMonoRegular text-xs uppercase text-black" htmlFor="anchorID">
            Anchor ID
            <input className="font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="text" type="text" value={state.anchor} readOnly={reusableComponent && reusableComponent} />
          </label>
          {/* <div className="font-americaMonoRegular text-xs uppercase mt-2 w-full pt-1 flex flex-row items-center" htmlFor="marginTop">
            <PageTypeCheckbox checked={state.marginTop === true} value="checkedA" onClick={handleMarginTop} />
            <span className="font-americaMonoRegular text-xs uppercase text-black" onChange={handleMarginTop} onClick={handleMarginTop}>
              Margin Top
            </span>
          </div> */}
        </div>
      </div>
    </>
  );
};

Anchor.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
};
Anchor.defaultProps = {
  reusableComponent: null,
};

export default Anchor;
